import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Navbar, Nav, Button, Container, Badge, Dropdown } from "react-bootstrap";
import { FaBell } from "react-icons/fa";

import uvegLogo from "./LOGO 2.png";
// import educaLogo from "./Escudo-IE.png";
import coachBlockchainLogo from "./logo1.png";

import styles from "./Navigation.module.css";
import VentanaEmergenteGeneral from "../Alerts/alert";
import notificationsData from "../../data/adsData";

const AuthenticatedNav = ({ account, setAccount }) => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const navRef = useRef(null);

  // Compensa el alto del navbar fijo para que el contenido no quede oculto
  useEffect(() => {
    const updateBodyPadding = () => {
      const h = navRef.current?.offsetHeight ?? 0;
      document.body.style.paddingTop = `${h}px`;
    };
    updateBodyPadding();
    window.addEventListener("resize", updateBodyPadding);
    return () => {
      window.removeEventListener("resize", updateBodyPadding);
      document.body.style.paddingTop = ""; // limpia al desmontar
    };
  }, []);

  const handleLogout = async () => {
    setAccount(null);
    localStorage.removeItem("walletAccount");
    sessionStorage.removeItem("walletAccount");

    if (window.ethereum) {
      try {
        await window.ethereum.request({
          method: "wallet_requestPermissions",
          params: [{ eth_accounts: {} }],
        });
      } catch (error) {
        console.error("Error al revocar permisos:", error);
      }
    }
    navigate("/");
  };

  if (!account) return null;

  return (
    <>
      {/* ✅ Fuerza fondo blanco global + tipografía serif en el navbar */}
      <style>{`
        .auth-nav-serif-root, .auth-nav-serif-root * {
          font-family: Georgia, "Times New Roman", Times, serif;
          letter-spacing: 0.01em;
        }
        html, body {
          background: #ffffff !important; /* ✅ fondo blanco en toda la página */
        }
      `}</style>

      <Navbar
        ref={navRef}
        expand="lg"
        bg="dark"
        variant="dark"
        fixed="top"
        className={`auth-nav-serif-root ${styles.navbar}`}
        style={{ zIndex: 1100 }}
      >
        <Container className={styles.containerFix}>
          <Navbar.Brand className="d-flex align-items-center gap-2">
            <img
              src={uvegLogo}
              className={`${styles.brandLogo} ${styles.uvegHalo}`}
              alt="UVEG"
              draggable="false"
            />
            {/* <img src={educaLogo} width="40" height="40" className={`${styles.logo} mx-3`} alt="Educa Logo" /> */}
            <img
              src={coachBlockchainLogo}
              className={styles.brandLogoB}
              alt="Coach Blockchain Logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="authenticated-navbar" />
          <Navbar.Collapse id="authenticated-navbar">
            <Nav className="me-auto">
              <Nav.Link as={NavLink} to="/course/profile" className={styles.navLink}>
                Profile
              </Nav.Link>
              <Nav.Link as={NavLink} to="/course/mint-nft" className={styles.navLink}>
                NFTs
              </Nav.Link>
              <Nav.Link as={NavLink} to="/course/my-NFTs" className={styles.navLink}>
                Mis NFT´s
              </Nav.Link>
              <Nav.Link as={NavLink} to="/course/crypto-tools" className={styles.navLink}>
                Exchanges
              </Nav.Link>
              {/* <Nav.Link as={NavLink} to="/course/trading-terminal" className={styles.navLink}>Trading</Nav.Link> */}
              <Nav.Link as={NavLink} to="/course/mint-certificate" className={styles.navLink}>
                MINT
              </Nav.Link>
              <Nav.Link as={NavLink} to="/course/NFT-certificate" className={styles.navLink}>
                Certificados
              </Nav.Link>
              <Nav.Link as={NavLink} to="/course/ia-respuestas" className={styles.navLink}>
                FAQ Inteligente
              </Nav.Link>
            </Nav>

            <Nav className="d-flex align-items-center">
              <Dropdown
                show={showDropdown}
                onToggle={() => setShowDropdown((s) => !s)}
              >
                <Dropdown.Toggle
                  variant="transparent"
                  id="alert-dropdown"
                  style={{ position: "relative", color: "#fff" }}
                >
                  <FaBell size={22} />
                  {notificationsData.length > 0 && (
                    <Badge
                      bg="danger"
                      pill
                      style={{ position: "absolute", top: "-6px", right: "-6px" }}
                    >
                      {notificationsData.length}
                    </Badge>
                  )}
                </Dropdown.Toggle>

                <Dropdown.Menu align="end">
                  {notificationsData.map((notif) => (
                    <Dropdown.Item
                      key={notif.id}
                      onClick={() => setSelectedNotification(notif)}
                    >
                      {notif.title}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <Nav.Link
                href={`https://etherscan.io/address/${account}`}
                target="_blank"
                rel="noopener noreferrer"
                className={`${styles.navButton} mx-3`}
              >
                <Button variant="outline-light" className={styles.accountButton}>
                  {account.slice(0, 6)}...{account.slice(-4)}
                </Button>
              </Nav.Link>

              <Button variant="danger" size="sm" onClick={handleLogout}>
                Cerrar sesión
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Modal de notificación (usa tu propio componente) */}
      {selectedNotification && (
        <VentanaEmergenteGeneral
          show={!!selectedNotification}
          title={selectedNotification.title}
          content={selectedNotification.content || selectedNotification.message}
          onHide={() => setSelectedNotification(null)}
        />
      )}
    </>
  );
};

export default AuthenticatedNav;
